export const accounts = [
  { value: 'Sales', label: 'Sales' },
  { value: 'Cost Of Goods', label: 'Cost Of Goods' },
  { value: 'Inventory', label: 'Inventory' },
  { value: 'Other Income', label: 'Other Income' },
];
